export default __webpack_public_path__ + "static/media/PNJ-impressionnism.98728d5e.png";